import type { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { RedirectComponent } from './pages/redirect/redirect.component';

/**
 * Authentication Routes
 * These routes handle the OAuth2/Cognito authentication flow
 * and are not protected by authGuard
 */
export const authRoutes: Routes = [
  {
    path: 'auth',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent,
        title: 'Login - BeFair Platform'
      },
      {
        path: 'callback',
        component: CallbackComponent,
        title: 'Authenticating - BeFair Platform'
      },
      {
        path: 'logout',
        component: LogoutComponent,
        title: 'Logging Out - BeFair Platform'
      },
      {
        path: 'redirect',
        component: RedirectComponent,
        title: 'Redirecting - BeFair Platform'
      }
    ]
  }
];
